import { NgModule } from '@angular/core';
import { UTabViewModule } from '@local/ui-infra';
import { CollectionsPageModule } from '../collections-page/collections-page.module';
import { AssistantIncontextComponent } from './components/assistant-incontext/assistant-incontext.component';

@NgModule({
  declarations: [AssistantIncontextComponent],
  imports: [CollectionsPageModule, UTabViewModule],
})
export class AssistantIncontextModule {}
